import React from 'react';

export default function IconSearch({
  height = 32,
  width = 32,
  className,
}: {
  height: number;
  width: number;
  className?: string;
}): React.ReactElement {
  return (
    <svg
      height={height}
      viewBox="0 0 32 32"
      width={width}
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      className={className}
    >
      <clipPath id="a">
        <path d="m0 0h32v32h-32z" />
      </clipPath>
      <clipPath id="b">
        <path d="m.111.111h46v46h-46z" />
      </clipPath>
      <clipPath id="c">
        <path
          d="m406.44 350.929a5.489 5.489 0 1 1 5.488 5.488 5.482 5.482 0 0 1 -5.488-5.488m-2.44 0a7.921 7.921 0 0 0 13.087 6.012l.331.341v.964l6.1 6.087 1.817-1.817-6.087-6.1h-.963l-.343-.329a7.926 7.926 0 1 0 -13.942-5.158"
          transform="translate(-404 -343)"
        />
      </clipPath>
      <path d="m0 0h32v32h-32z" opacity="0" />
      <g clipPath="url(#a)">
        <g clipPath="url(#b)" opacity="0" transform="translate(-7.111 -7.111)">
          <path d="m0 0h46v46h-46z" fill="#fff" transform="translate(.111 .111)" />
        </g>
      </g>
      <g clipPath="url(#c)" transform="translate(5.334 5.333)">
        <path d="m0 0h34v34h-34z" transform="translate(-6.334 -6.333)" />
      </g>
    </svg>
  );
}
